import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChatOptions from "./ChatOptions";
import { Image } from "react-bootstrap";
import smileChatIcon from "../../../assets/icons/smileChatIcon.svg";
import { getLocalFormatedTime } from "../../../utils/helpers/calculateTime";
import { PinChatFillIcon } from "../../../assets/svgs/SvgsImg";
import { getChatMessageHtml } from "../../../utils/helpers/chatMessageContent";
import {
  getChatConversations,
  SearchConversations,
} from "../../../redux/actions/chatActions";

const RoomListWrapper = ({
  chatRooms,
  loading,
  onSelect,
  selectedRoom,
  selectChat,
  rightSideMenuStat,
  searchStat,
  searchConversation,
  setIsAttached,
  currentUserId,
  dispatch,
  showArchive,
  setShowAdminDrop,
  setAscShowChat,
  NoSearchYet,
  searchText,
  searchPeople,
  setSearchPeople,
}) => {
  // mine start
  const reduxDispatch = useDispatch();

  const searchConversationsResponse = useSelector(
    (state) => state.chat.searchConversationsResponse,
  );

  let filteredChats = chatRooms?.filter((x) => x.isArchived === showArchive);

  // Search filter
  if (searchPeople) {
    filteredChats = filteredChats.filter((item) =>
      item.groupname?.toLowerCase().includes(searchPeople.toLowerCase()),
    );
  }

  // API search call
  useEffect(() => {
    if (searchPeople?.trim().length > 0) {
      reduxDispatch(SearchConversations(searchPeople.trim(), currentUserId));
    }
  }, [searchPeople]);

  if (
    searchConversationsResponse?.status === true &&
    searchPeople?.length !== 0
  ) {
    const rawData = [...(searchConversationsResponse?.data?.users || [])];

    const filteredApiData = rawData.filter((item) =>
      item.groupname?.toLowerCase().includes(searchPeople.toLowerCase()),
    );

    // Only add API results that don't already have an existing room (by userid)
    const existingUserIds = new Set(
      filteredChats.map((item) => item.userid).filter(Boolean),
    );
    const existingGroupIds = new Set(
      filteredChats.map((item) => item.groupid).filter(Boolean),
    );
    const existingGroupNames = new Set(
      filteredChats
        .map((item) => item.groupname?.toLowerCase()?.trim())
        .filter(Boolean),
    );

    const newApiResults = filteredApiData.filter((item) => {
      // Skip if we already have a room with this user, groupname or groupid
      if (item.userid && existingUserIds.has(item.userid)) return false;
      if (item.groupid && existingGroupIds.has(item.groupid)) return false;
      if (
        item.groupname &&
        existingGroupNames.has(item.groupname?.toLowerCase()?.trim())
      )
        return false;
      return true;
    });

    filteredChats = [...filteredChats, ...newApiResults];
  }

  // mine end

  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  if (loading) {
    return <span>Loading...</span>;
  }

  if (NoSearchYet) {
    return (
      <div className="pt-5 p-3 text-center" style={{ fontSize: "14px" }}>
        <Image src={smileChatIcon} width={49} height={48} alt="#"></Image>
        <p className="pt-3">
          Try to refine your search or enter a new to find co-workers to chat
          with.
        </p>
      </div>
    );
  }

  const filteredChats2 = chatRooms?.filter((x) => x.isArchived === showArchive);

  if (!filteredChats) {
    return <span>No users found!</span>;
  }

  const getFormattedMessage = (message) => {
    let htmlMessage = "";
    let convertedHtml = getChatMessageHtml(message);
    if (convertedHtml != "<p><br></p>") {
      htmlMessage = convertedHtml;
    }
    return htmlMessage;
  };

  return filteredChats.map((room, index) => {
    console.log("asd33", room);
    return (
      <div
        className={
          selectedRoom && room.groupid === selectedRoom.groupid
            ? `single-person  c02A29B`
            : `single-person    e-person`
        }
        key={`room-${index}`}
      >
        <div className="single-person-grid">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              flexGrow: 1,
            }}
            onClick={() => {
              onSelect(room);
              selectChat(false);
              rightSideMenuStat(false);
              searchStat(false);
              searchConversation(false);
              setIsAttached(false);
              setShowAdminDrop(false);
              // if (!room.groupid) {
              //   const groupUser = [
              //     { groupmember: room?.userid },
              //     { groupmember: currentUserId },
              //   ];
              //   dispatch(addIndividualGroups(currentUserId, "", groupUser));
              // }
              setAscShowChat(true);
              setSearchPeople("");
            }}
          >
            <div className="name-image-style temp-image-style position-relative">
              {room?.groupicon ? (
                <img
                  className="avatar_default-View"
                  src={room?.groupicon}
                  alt=""
                  style={{
                    objectFit: "cover",
                    zIndex: "0",
                    borderRadius: "100%",
                  }}
                />
              ) : (
                <>
                  {room?.groupname && (
                    <div
                      className="avatar_default-View"
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {room?.groupname?.split(" ")[1]
                        ? `${room?.groupname
                            ?.split(" ")[0][0]
                            ?.toUpperCase()}${room?.groupname
                            ?.split(" ")[1][0]
                            ?.toUpperCase()}`
                        : `${room?.groupname
                            ?.split(" ")[0][0]
                            ?.toUpperCase()}${room?.groupname
                            ?.split(" ")[0][1]
                            ?.toUpperCase()}`}
                    </div>
                  )}
                </>
              )}
            </div>

            {room?.type !== "Group" && (
              <div
                className="on-off-status"
                style={{ background: room?.isOnline ? "green" : "lightgray" }}
              ></div>
            )}

            <div className="d-flex flex-grow-1">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  textAlign: "start",
                  justifyContent: "center",
                  width: "100%",
                }}
                className="ms-2"
              >
                <span className="chat-room-name-style">{room?.groupname}</span>
                <div className="frc" style={{ columnGap: "0.25rem" }}>
                  <p
                    style={{
                      color: "#95a7c6",
                      fontWeight: 700,
                      fontSize: "13px",
                    }}
                    className="mb-0"
                  >
                    {room?.isdraft && !room?.isdeleted ? "Draft:" : ""}
                  </p>
                  {isJson(room?.lastmessages) ? (
                    <span
                      className="people-inbox-message"
                      dangerouslySetInnerHTML={{
                        __html:
                          room?.isdraft && room?.isdeleted
                            ? ""
                            : room?.isdeleted
                              ? "This message was deleted"
                              : getFormattedMessage(room?.lastmessages),
                      }}
                    ></span>
                  ) : (
                    <span className="people-inbox-message">
                      {room?.lastmessages}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="people-inbox-time-div">
            <span className="people-inbox-time">
              {getLocalFormatedTime(room?.createdat, "CHATLIST")?.replace(
                /January|February|March|April|May|June|July|August|September|October|November|December/,
                (month) => month.slice(0, 3),
              )}
            </span>
            <div className="d-flex align-items-center gap-1">
              {room.unreadreceivermessagecount > 0 && (
                <div
                  className={`message-icon-main2 ${
                    room.isMuted ? "isMuted-notification" : ""
                  }`}
                >
                  {room.unreadreceivermessagecount}
                </div>
              )}
              {room.isPinned && <PinChatFillIcon />}
              <ChatOptions
                room={room}
                groupid={room.groupid}
                isPinned={room.isPinned}
                isArchived={room.isArchived}
                key={`romm-option-${room.groupid}`}
              />
            </div>
          </div>
        </div>
        <div className="people-inbox-under"></div>
      </div>
    );
  });
};

export default RoomListWrapper;
